import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "col": "12"
    }
  }, [_c('h4', {
    staticClass: "text-bold px-0 mx-0 mb-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.access')))]), _c('div', {
    staticClass: "card-description my-0",
    staticStyle: {
      "max-width": "65vw"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.selectTheParentalObject')) + "\n          ")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.account,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.deviceAccount'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": "",
      "data-cy": "device_account"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.template && _vm.template.deviceMeta ? _c('core-dtwin-finder', {
    attrs: {
      "objectFilter": _vm.parentSelectorFilter,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.template.tenantId,
      "hideDetails": "",
      "readonly": ""
    },
    model: {
      value: _vm.template.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.template, "parentId", $$v);
      },
      expression: "template.parentId"
    }
  }) : _vm._e(), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.parentDigitalTwinHint')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.scopeDetailedName,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.scope'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": "",
      "data-cy": "device_scope"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.scopeText')))])], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "col": "12"
    }
  }, [_c('h4', {
    staticClass: "text-bold px-0 mx-0 mb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.connector')) + "\n          ")]), _c('div', {
    staticClass: "card-description my-0",
    staticStyle: {
      "max-width": "65vw"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.predefineConnector')) + "\n          ")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.connector'),
      "items": _vm.deviceBridgesForAccount,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "disabled": "",
      "data-cy": "device_connector"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[data.item.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[data.item.type],
            "alt": data.item.name,
            "title": data.item.name
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(data.item.type.replace('bridge-', '')) + " (ID " + _vm._s(data.item.id) + ")\n                ")])], 1)];
      }
    }]),
    model: {
      value: _vm.selectedBridge,
      callback: function ($$v) {
        _vm.selectedBridge = $$v;
      },
      expression: "selectedBridge"
    }
  })], 1)], 1), _vm.template ? _c(VRow, _vm._l(_vm.bridgeCreateFields, function (configKey) {
    return _c(VCol, {
      key: `bridge_config_item_${configKey}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "fieldConfig": _vm.bridgeCreateParameters[configKey],
        "bridgeConfig": _vm.get(_vm.selectedBridge, 'bridge.config', {}),
        "bridgeConfigId": _vm.selectedBridge.id,
        "bridgeType": _vm.selectedBridge.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeConfig(_vm.selectedBridge).manifest,
        "bridgeHasValidParametersStrict": false,
        "disabled": _vm.isProductiveVersion || _vm.readonly || _vm.notEditableConnectorFields.includes(configKey) && _vm.allConnectorFieldsSet,
        "dependsOnFieldValue": _vm.getDependsOnFieldValue(_vm.bridgeCreateParameters, configKey, _vm.template.deviceMeta.connectorData),
        "bridgeHasValidParameters": "",
        "brigdeHasError":
        // component must have brigdeHasError to add required rules for the field
        // https://digimondo.atlassian.net/browse/RD-6070
        true
      },
      model: {
        value: _vm.template.deviceMeta.connectorData[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.template.deviceMeta.connectorData, configKey, $$v);
        },
        expression: "template.deviceMeta.connectorData[configKey]"
      }
    })], 1);
  }), 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "col": "12"
    }
  }, [_c('h4', {
    staticClass: "text-bold px-0 mx-0 mb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.tagsGroups')) + "\n          ")]), _c('div', {
    staticClass: "card-description my-0",
    staticStyle: {
      "max-width": "65vw"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.defineTagsGroups')) + "\n          ")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12"
    }
  }, [_vm.template && _vm.template.deviceMeta ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-tags', {
    attrs: {
      "tags": _vm.get(_vm.template, 'deviceMeta.tags', []),
      "label": _vm.$i18n_t('Common.tags'),
      "disabled": _vm.isProductiveVersion || _vm.readonly,
      "dataCy": 'template_tags'
    },
    on: {
      "update:tags": _vm.setTags
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-device-template-groups', {
    attrs: {
      "tenantId": _vm.template.tenantId,
      "deviceMeta": _vm.template.deviceMeta,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceGroups'),
      "readonly": _vm.isProductiveVersion || _vm.readonly
    },
    on: {
      "groupsChosen": _vm.setGroups
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm.template && _vm.template.deviceMeta ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "7",
      "lg": "7",
      "sm": "7"
    }
  }, [_c('core-device-template-key-value-editor', {
    attrs: {
      "deviceMeta": _vm.template.deviceMeta,
      "property": 'customProperties',
      "header": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.keyValue'),
      "description": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.keyValueText'),
      "keyLabel": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.key'),
      "valueLabel": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.defaultValue'),
      "isProductiveVersion": _vm.isProductiveVersion,
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.template.deviceMeta.customProperties,
      callback: function ($$v) {
        _vm.$set(_vm.template.deviceMeta, "customProperties", $$v);
      },
      expression: "template.deviceMeta.customProperties"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "col": "12"
    }
  }, [_c('h4', {
    staticClass: "text-bold px-0 mx-0 mb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.icon')) + "\n          ")]), _c('div', {
    staticClass: "card-description my-0",
    staticStyle: {
      "max-width": "65vw"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.configureIcon')) + "\n          ")])])], 1), _c(VRow, [_vm.template && _vm.template.deviceMeta ? _c(VCol, {
    attrs: {
      "cols": "6",
      "lg": "6",
      "sm": "6",
      "md": "6"
    }
  }, [_c('core-icons', {
    attrs: {
      "disabled": _vm.isProductiveVersion || _vm.readonly,
      "faStyle": "light",
      "dense": ""
    },
    model: {
      value: _vm.template.deviceMeta.faIcon,
      callback: function ($$v) {
        _vm.$set(_vm.template.deviceMeta, "faIcon", $$v);
      },
      expression: "template.deviceMeta.faIcon"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };